import { FieldValues, UseFormGetValues, UseFormReset, UseFormSetValue } from "react-hook-form";
import { ISelectOptions } from "src/@types/select";
import { IPayment } from "src/@types/stores";

interface Relation {
  array1Item: any;
  array2Items: any[];
}

export function useShuffle() {
  function shuffleArray<T>(array: T[]): T[] {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const randomIndex = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[randomIndex]] = [newArray[randomIndex], newArray[i]];
    }
    return newArray;
  }

  
  function handleRaffleAnalystsAndRegionals(setValue: UseFormSetValue<FieldValues>, data: IPayment[] | never[], analystsOptions: ISelectOptions | undefined, regionalOptions: ISelectOptions | undefined) {
    const shuffledAnalysts = shuffleArray(analystsOptions?.map(a => a.value) ?? []);
    const shuffledRegional = shuffleArray(regionalOptions?.map(a => a.value) ?? []);

    if (shuffledAnalysts.length < 1 || shuffledRegional.length < 1 || data.length < 1) return

    const relationOfStoresPerRegional = balanceRelations(shuffledRegional, data)

    const relationOfRegionalPerAnalyst = balanceRelations(shuffledAnalysts, shuffledRegional)

    for (const regionalsPerAnalyst of relationOfRegionalPerAnalyst) {

      for (const storesPerRegional of relationOfStoresPerRegional) {

        if (regionalsPerAnalyst.array2Items.find(regional => regional === storesPerRegional.array1Item)) {

          for (const store of storesPerRegional.array2Items) {
            setValue(`store_${store.id}.analyst`, regionalsPerAnalyst.array1Item)
            setValue(`store_${store.id}.regional`, storesPerRegional.array1Item) // sorteia as regionais também
          }
        }
      }
    }
  }

  const balanceRelations = <T, U>(array1: T[], array2: U[]): Relation[] => {
    const array1Length = array1.length;
    const array2Length = array2.length;

    // Quantidade mínima de itens do array2 que serão relacionados com cada item do array1
    const minRelation = Math.floor(array2Length / array1Length);

    // Quantidade de itens do array2 que precisarão de uma relação extra
    const extraRelations = array2Length % array1Length;

    const relations: Relation[] = [];
    let currentIndex = 0;

    array1.forEach((item, index) => {
      // Define quantos itens do array2 vão se relacionar com o item atual do array1
      const numberOfRelations = minRelation + (index < extraRelations ? 1 : 0);

      // Pega os itens do array2 para relacionar com o item atual do array1
      const relatedItems = array2.slice(currentIndex, currentIndex + numberOfRelations);
      currentIndex += numberOfRelations;

      // Armazena a relação
      relations.push({
        array1Item: item,
        array2Items: relatedItems,
      });
    });

    return relations;
  };

  function handleRaffleAnalysts(getValues: UseFormGetValues<FieldValues>, reset: UseFormReset<FieldValues>, data: IPayment[] | never[], analystsOptions: ISelectOptions | undefined) {
    const shuffledAnalysts = shuffleArray(analystsOptions?.map(a => a.value) ?? []);

    if (shuffledAnalysts.length < 1 || data.length < 1) return;

    const currentValues = getValues();
    const updatedValues = { ...currentValues };
    const relationOfStoresPerAnalyst = balanceRelations(shuffledAnalysts, data);

    for (const storesPerAnalyst of relationOfStoresPerAnalyst) {
      for (const store of storesPerAnalyst.array2Items) {
        const key = `store_${store.code}`;
        updatedValues[key] = { ...updatedValues[key], analyst: storesPerAnalyst.array1Item };
      }
    }

    reset(updatedValues);
  }

  return {
    balanceRelations,
    shuffleArray,
    handleRaffleAnalystsAndRegionals,
    handleRaffleAnalysts
  }
}